export default {
  /* This section was auto-generated by bzs-helper ($Properties$) */
  address: { field: 'address', fieldType: 'text' },
  code: { field: 'code', fieldType: 'text', required: true, label: 'Company Code' },
  companyId: { field: 'companyID', fieldType: 'numeric' },
  companyName: { field: 'companyName', fieldType: 'text', required: true },
  createdOn: { field: 'createdOn', fieldType: 'date' },
  logoPath: { field: 'logoPath', fieldType: 'text' },
  modifiedOn: { field: 'modifiedOn', fieldType: 'date' }
};
